// extracted by mini-css-extract-plugin
export default {"backout":"styles_backout__YGNjp","bp4-non-ideal-state":"styles_bp4-non-ideal-state__en0Fc","tall":"styles_tall__p5-n6"};